export default "__VITE_ASSET__daf97854__"